module.exports = __webpack_public_path__ + "static/img/1.3ec69e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Multiriesgo-corporativo/1.png
// module id = kDpt
// module chunks = 0